import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { JsonFormData } from '../shared/components/json-form/json-form.component';
import { VendorService } from '../shared/vendor.service';
import { InstructionsComponent } from '../instructions/instructions.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarService } from '../shared/progress-bar.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-questions-details',
  templateUrl: './questions-details.component.html',
  styleUrls: ['./questions-details.component.css','../shared/css/common.css']
})
export class QuestionsDetailsComponent implements OnInit {

  public questionsForm = this.questionsFormBuilder.group({});
  questionsFormData! : JsonFormData;
  count: number = 4000;
  formdata: any;
  questionsFormDataJson: any;
  payorkey: number;
  formLoaded = false;
  isFormValid: boolean = false;

  instructionText!: string | null;
  isInstruction: boolean = false;
  IsUploadAttatchment: boolean = false;
  primaryColor?: string = "";
  private uploadFileDataSub!: Subscription;

  constructor(
    private questionsFormBuilder: FormBuilder, 
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal,
    private progressBarService: ProgressBarService
  ) {
    this.payorkey = parseInt(sessionStorage.getItem("payorkey")?? "0"); 
    const control: any={
      "name": "",
      "label": "",
      "value": "",
      "type": "textarea",
      
      "validators": {
        "required": false,
        "maxLength": 2000
      }
    };
    this.formdata = this.vendorService.getSessionData();
       
   }

  ngOnInit(): void {
    if(this.formdata.questionsDetails && this.formdata.questionsDetails.controls){
      this.questionsFormData = { controls : []};
      this.questionsFormData.controls = this.formdata.questionsDetails.controls;
      this.questionsFormDataJson = [];
      this.formLoaded = true; 
    }else{
      this.questionsFormDataJson = this.formdata.questionsDetails;
    }

    this.vendorService.getRequiredFields(this.payorkey, this.vendorService.getStoredInstanceNumber()).subscribe((result)=>{    
      this.IsUploadAttatchment = result.IsUploadAttatchment;
    });

    this.vendorService.getLeadQuestion(this.payorkey, this.vendorService.getStoredInstanceNumber()).subscribe((result)=>{
      this.formLoaded = true; 
      let keys = Object.keys(result);
      if(!Array.isArray(this.questionsFormDataJson) || ( Array.isArray(this.formdata.questionsDetails) && this.formdata.questionsDetails.length == 0)) {     
        this.questionsFormData = { controls : []};
        let Qno = 0;
        for(let i=1;i<=50;i++){
          let active= keys.find(x => x.toLowerCase() == ('IsQuestion'+i+'Active').toLowerCase());
          let displayunknown = keys.find(x => x.toLowerCase() == ('IsQuestion'+i+'DisplayUnknown').toLowerCase());
          let required = keys.find(x => x.toLowerCase() == ('IsQuestion'+i+'DisplayText').toLowerCase());       
  
          if(active && result[active]) {
            Qno++;
            let label = ((result['Question' + i]).replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span><br/>'))+'##end';
            let isRequired =(required && result[required]);
            if(isRequired)
            {
              label = label.replace(/<br\/>##end/g, '<span class="dynRequired">&nbsp;(Required)</span>')
              label = label.replace(/##end/g, '<span class="dynRequired">&nbsp;(Required)</span>')
            }
            else{
              label = label.replace(/##end/g, '')
            }
            if(displayunknown && result[displayunknown] == "1") {
              this.questionsFormData.controls.push({
                "name": "questiondDrDown" + i,
                "label": label,
                "value": "",
                "type": "select",
                "options": [
                  {
                    "key": "Yes",
                    "value": "Yes"
                  },
                  {
                    "key": "No",
                    "value": "No"
                  },
                  {
                    "key": "Unknown",
                    "value": "Unknown"
                  }
                  ,
                  {
                    "key": "Not Applicable",
                    "value": "Not Applicable"
                  }
                ],
                "validators": {
                  "required": isRequired,
                  "maxLength": 200
                },
                placeholder: '',
                required: false
              });
            }    
            else if(displayunknown && result[displayunknown] == "2") {
            this.questionsFormData.controls.push({
              "name": "questionTxt" + i,
              "label": label,
              "value": "",
              "type": "textarea",

              "options": {
                "showCount": true,
                "count": 0
              },
              "validators": {
                "required": isRequired,
                "maxLength": 2000
              },
              placeholder: '',
              required: false
            });  
          }        
          }
        }
      
    }
    });

    this.vendorService.getLeadHeaders(this.payorkey, this.vendorService.getStoredInstanceNumber()).subscribe((result)=>{          
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText =  result.Instruction;
      instructionText = instructionText.replace('<img ','<img title="Header" ')
      this.instructionText = instructionText;
    });

    this.uploadFileDataSub = this.vendorService.getUploadFileData().subscribe((result) => {
      if(result != null && result.length > 0) {
        this.vendorService.uploadFiles = [];
        result.forEach((item: any)=> {
          this.vendorService.uploadFiles.push(item.fileName);
        });
      }
      else {
        this.vendorService.uploadFiles = [];
      }
    });
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }

      this.isFormValid = !this.questionsForm.invalid;
      this.progressBarService.sendData(true);
    });
  }

  back() {
    if (this.questionsFormData) {
      this.formdata.questionsDetails = this.questionsFormData;
    }
    if(this.isFormValid) {
      window.sessionStorage.setItem("QuestionsFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("QuestionsFormValid");
    }

    this.vendorService.updateData(this.formdata);

    this.router.navigate(['additionalInvolvedParties']);
    setTimeout(() => {
      this.progressBarService.sendData(true);
    });
  }


  valueChangeEvent(data: any) {
    if(this.questionsFormData){
      this.formdata.questionsDetails = this.questionsFormData; 
    }
    
    this.isFormValid = !this.questionsForm.invalid;
    this.cdref.detectChanges();
    if(this.isFormValid) {
      window.sessionStorage.setItem("QuestionsFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("QuestionsFormValid");
    }
    this.vendorService.updateData(this.formdata);
  }

  openInstruction() {
    const result  = this.modalService.open(InstructionsComponent, {size: 'lg',  ariaLabelledBy: 'Instructions'});
    result.componentInstance.name = this.instructionText;
  }

  submitQuestions() {
    if(this.isFormValid) {
      window.sessionStorage.setItem("QuestionsFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("QuestionsFormValid");
    }
    
    sessionStorage.setItem('activeformdata', JSON.stringify(this.formdata));
    this.router.navigate(['submit']);
  }
  
  ngOnDestroy(): void {
    if (this.uploadFileDataSub) {
      this.uploadFileDataSub.unsubscribe();
    }
  }

}
